import { f as flattenChildren } from '../unsorted/index3.js';
import { isChildSubcomponent } from '../utils/subcomponentHelpers.js';

function useGetSubcomponentChild(children, subcomponent) {
  return flattenChildren(children).find(function (child) {
    if (Array.isArray(subcomponent)) {
      return subcomponent.some(function (sub) {
        return isChildSubcomponent(child, sub);
      });
    }
    return isChildSubcomponent(child, subcomponent);
  });
}

export { useGetSubcomponentChild };
//# sourceMappingURL=useGetSubcompnentChild.js.map
